import { mutation_keys } from "../mutations";

/**
 * App action keys.
 * @type {import("../types/actions/account").AccountActionKeys}
 */
const account_action_keys = {
    "SET": "ACCOUNT/SET",
}

/**
 * App specific actions.
 * @type {import("../types/actions/account").AccountActions}
 */
const account_actions = {
    /** 
     * Setting account.
     */
    [account_action_keys.SET]: ({ commit }, account) => {
        commit(mutation_keys.account.SET, account);
    },
};

export { account_action_keys };

export default account_actions;